export default __webpack_public_path__ + "static/media/ic_mail_primary.8f91a554.svg";